import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';


@Component({
  selector: 'app-video-main',
  standalone: false,
  templateUrl: './video-main.html',
  styleUrl: './video-main.scss'
})
export class VideoMain {
@Input() list: any[] = [];
@Input() count: number = 0;
@Input() answer1: string = "";
@Output() emitService = new EventEmitter<any>();

  submit() {
    this.emitService.emit({ answer1: this.answer1, id: this.list[this.count].id, qobj: this.list[this.count] });
  }
  closeVideo(): void {
    
    
}

}
